import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SHr, SPage, SText, STheme, SView } from 'servisofts-component';
import { Container } from '../Components';
class index extends Component {
    render() {
        return <SPage
            // navBar={this.navBar()}
            // footer={this.footer()}
            title={"Política de Privacidad"}
        >
            <Container >
                <SHr height={40} />
                <SText bold center fontSize={18} >{`POLÍTICA DE PRIVACIDAD DE LA APLICACIÓN RENOVA`}</SText>
                <SHr height={20} />
                <SView col={"xs-12"}  >
                    <SText fontSize={16} bold style={{ textTransform: "uppercase" }}>
                        1. Introducción
                    </SText>
                </SView>
                <SText style={{ textAlign: 'justify' }}>
                    Bienvenido a RENOVA. Esta política de privacidad explica cómo recopilamos, utilizamos, compartimos y protegemos la información personal de los usuarios de nuestra aplicación. RENOVA se compromete a proteger su privacidad y a asegurar que sus datos personales sean manejados de manera segura.
                </SText>
                <SHr height={10} />

                <SView col={"xs-12"}  >
                    <SText fontSize={16} bold style={{ textTransform: "uppercase" }}>
                        2. Enlace y Acceso
                    </SText>
                </SView>
                <SText style={{ textAlign: 'justify' }}>
                    Esta política de privacidad está disponible directamente desde nuestra página de listado en la Play Store y dentro de la aplicación "RENOVA" bajo la sección de Ajustes - Política de Privacidad.
                </SText>
                <SHr height={20} />

                <SView col={"xs-12"}  >
                    <SText fontSize={16} bold style={{ textTransform: "uppercase" }}>
                        3. Entidad Responsable
                    </SText>
                </SView>
                <SView col={"xs-12"}  >
                    <SText style={{ textAlign: 'justify' }}>
                        La entidad responsable de la recopilación y procesamiento de sus datos personales bajo esta política es:
                    </SText>
                </SView>

                <SHr />
                <SView col={"xs-12"}  >
                    <SText >
                        RENOVA   </SText>
                    <SText style={{}}>
                        Av. Los Bosques, calle 11 (100 mts antes del 4to anillo) 1 cuadra antes de la Radial 17</SText>
                    <SText style={{}}>
                        Correo electrónico de contacto: contacto@RENOVA.com
                    </SText>
                </SView>
                <SHr height={20} />

                <SView col={"xs-12"}  >
                    <SText fontSize={16} bold style={{ textTransform: "uppercase" }}>
                        4. Datos que Recopilamos
                    </SText>
                </SView>
                <SView col={"xs-12"}  >
                    <SText style={{ textAlign: 'justify' }}>
                        Recopilamos varios tipos de información, incluyendo:
                    </SText>
                </SView>
                <SHr />
                <SView col={"xs-12"} row   >
                    <SView col={"xs-0.3"} style={{
                        width: 8,
                        height: 8,
                        borderRadius: 5,
                        backgroundColor: STheme.color.text,
                        marginRight: 5,
                        marginTop: 10,
                    }} />
                    <SView col={"xs-11"}>
                        <SText style={{}}>
                            Datos personales como nombre, dirección de correo electrónico y número de teléfono.
                        </SText>
                    </SView>
                </SView>
                <SView col={"xs-12"} row   >
                    <SView col={"xs-0.3"} style={{
                        width: 8,
                        height: 8,
                        borderRadius: 5,
                        backgroundColor: STheme.color.text,
                        marginRight: 5,
                        marginTop: 10,
                    }} />
                    <SView col={"xs-11"}>
                        <SText style={{}}>
                            Datos sensibles que pueden incluir la ubicación geográfica para usuarios repartidores.
                        </SText>
                    </SView>
                </SView>
                <SView col={"xs-12"} row   >
                    <SView col={"xs-0.3"} style={{
                        width: 8,
                        height: 8,
                        borderRadius: 5,
                        backgroundColor: STheme.color.text,
                        marginRight: 5,
                        marginTop: 10,
                    }} />
                    <SView col={"xs-11"}>
                        <SText style={{}}>
                            Información de uso y preferencias de la aplicación.
                        </SText>
                    </SView>
                </SView>
                <SHr height={20} />

                <SView col={"xs-12"}  >
                    <SText fontSize={16} bold style={{ textTransform: "uppercase" }}>
                        5. Uso de la Información
                    </SText>
                </SView>
                <SView col={"xs-12"}  >
                    <SText style={{ textAlign: 'justify' }}>
                        Usamos la información recopilada para:
                    </SText>
                </SView>
                <SHr />
                <SView col={"xs-12"} row   >
                    <SView col={"xs-0.3"} style={{
                        width: 8,
                        height: 8,
                        borderRadius: 5,
                        backgroundColor: STheme.color.text,
                        marginRight: 5,
                        marginTop: 10,
                    }} />
                    <SView col={"xs-11"}>
                        <SText style={{}}>
                            Proveer, operar y mejorar nuestra aplicación.
                        </SText>
                    </SView>
                </SView>
                <SView col={"xs-12"} row   >
                    <SView col={"xs-0.3"} style={{
                        width: 8,
                        height: 8,
                        borderRadius: 5,
                        backgroundColor: STheme.color.text,
                        marginRight: 5,
                        marginTop: 10,
                    }} />
                    <SView col={"xs-11"}>
                        <SText style={{}}>
                            Comunicarnos con usted sobre actualizaciones, ofertas y promociones.
                        </SText>
                    </SView>
                </SView>
                <SView col={"xs-12"} row   >
                    <SView col={"xs-0.3"} style={{
                        width: 8,
                        height: 8,
                        borderRadius: 5,
                        backgroundColor: STheme.color.text,
                        marginRight: 5,
                        marginTop: 10,
                    }} />
                    <SView col={"xs-11"}>
                        <SText style={{}}>
                            Atender sus consultas y solicitudes de servicio al cliente.
                        </SText>
                    </SView>
                </SView>
                <SHr height={20} />

                <SView col={"xs-12"}  >
                    <SText fontSize={16} bold style={{ textTransform: "uppercase" }}>
                        6. Compartición de Información
                    </SText>
                </SView>
                <SView col={"xs-12"}  >
                    <SText style={{ textAlign: 'justify' }}>
                        Podemos compartir su información personal con:
                    </SText>
                </SView>
                <SHr />
                <SView col={"xs-12"} row   >
                    <SView col={"xs-0.3"} style={{
                        width: 8,
                        height: 8,
                        borderRadius: 5,
                        backgroundColor: STheme.color.text,
                        marginRight: 5,
                        marginTop: 10,
                    }} />
                    <SView col={"xs-11"}>
                        <SText style={{}}>
                            Proveedores de servicios que nos ayudan con nuestras operaciones comerciales.
                        </SText>
                    </SView>
                </SView>
                <SView col={"xs-12"} row   >
                    <SView col={"xs-0.3"} style={{
                        width: 8,
                        height: 8,
                        borderRadius: 5,
                        backgroundColor: STheme.color.text,
                        marginRight: 5,
                        marginTop: 10,
                    }} />
                    <SView col={"xs-11"}>
                        <SText style={{}}>
                            Entidades legales, en respuesta a procedimientos legales como órdenes de la corte.
                        </SText>
                    </SView>
                </SView>
                <SHr height={20} />

                <SView col={"xs-12"}  >
                    <SText fontSize={16} bold style={{ textTransform: "uppercase" }}>
                        7. Seguridad de los Datos
                    </SText>
                </SView>
                <SText style={{ textAlign: 'justify' }}>
                    Implementamos medidas de seguridad técnicas y organizativas para proteger sus datos personales contra el acceso no autorizado, la alteración, la divulgación o la destrucción.
                </SText>
                <SHr height={20} />

                <SView col={"xs-12"}  >
                    <SText fontSize={16} bold style={{ textTransform: "uppercase" }}>
                        8. Retención y Eliminación de Datos
                    </SText>
                </SView>
                <SView col={"xs-12"}  >
                    <SText style={{ textAlign: 'justify' }}>
                        Retenemos su información personal solo durante el tiempo necesario para los fines establecidos en esta política de privacidad. Usted puede solicitar la eliminación de sus datos personales contactándonos directamente.
                    </SText>
                </SView>
                <SHr height={10} />

                <SView col={"xs-12"}  >
                    <SText fontSize={16} bold style={{ textTransform: "uppercase" }}>
                        9. Contacto
                    </SText>
                </SView>
                <SView col={"xs-12"}  >
                    <SText style={{ textAlign: 'justify' }}>
                        Para cualquier pregunta o inquietud respecto a nuestra política de privacidad, por favor contacte a nuestro oficial de privacidad en contacto@RENOVA.com.
                    </SText>
                </SView>
                <SHr height={20} />

                <SView col={"xs-12"}  >
                    <SText fontSize={16} bold style={{ textTransform: "uppercase" }}>
                        10. Cambios en la Política de Privacidad
                    </SText>
                </SView>
                <SText style={{ textAlign: 'justify' }}>
                    RENOVA puede modificar esta política de privacidad periódicamente. Cualquier cambio será comunicado a través de nuestra aplicación o por correo electrónico.
                </SText>
                <SHr />
                <SHr height={40} />
            </Container>
        </SPage>
    }

}
const initStates = (state) => {
    return { state }
};
export default connect(initStates)(index);